import { Breadcrumb } from '@chakra-ui/react'
import { Link } from '@tanstack/react-router'
import React from 'react'

type Props = {
  paths: { name: string; path: string }[]
}

export function BreadCrumbs({ paths }: Readonly<Props>) {
  const lastIndex = paths.length - 1
  return (
    <Breadcrumb.Root>
      <Breadcrumb.List>
        {paths.map(({ name, path }, index) => (
          <React.Fragment key={name}>
            <Breadcrumb.Item>
              {index === lastIndex ? (
                <Breadcrumb.CurrentLink>{name}</Breadcrumb.CurrentLink>
              ) : (
                <Breadcrumb.Link asChild>
                  <Link to={path}>{name}</Link>
                </Breadcrumb.Link>
              )}
            </Breadcrumb.Item>
            {index < lastIndex && (
              <Breadcrumb.Separator key={`separator-${name}`} />
            )}
          </React.Fragment>
        ))}
      </Breadcrumb.List>
    </Breadcrumb.Root>
  )
}
